import { useMutation, useQueryClient } from "react-query";
import { WorkspaceArchiveFileData } from "@interfaces/company/workspace";
import { workspaceService } from "@services/workspace-service";
import { workspaceQueryKeys } from "./queryKeys";

export const useArchiveWorkspaceFileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: WorkspaceArchiveFileData) => workspaceService.archiveFile(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(workspaceQueryKeys.allDirectoriesFiles);
      },
    }
  );
};
